 import React from "react";
import ReactDOM from "react-dom"; // Import ReactDOM directly
import "./index.css";
import App from "./App";
import Home1 from "./pages/Home1";
import Herbs from "./pages/Herbs";
import Shrubs from "./pages/Shrubs";
import Trees from "./pages/Trees";
import Aboutus from "./pages/Aboutus";
//import Admincom from "./pages/Admincom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Share from "./components/Share";
import Gallery from "./pages/Gallery";

ReactDOM.render(
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/Home" element={<Home1 />} />
      <Route path="/Herbs" element={<Herbs />} />
      <Route path="/Shrubs" element={<Shrubs />} />
      <Route path="/Trees" element={<Trees />} />
      <Route path="/Aboutus" element={<Aboutus />} />
      <Route path="/Gallery" element={<Gallery />} />
      <Route path="/Share" element={<Share title="Herbal Cartel" />} />
    </Routes>
  </Router>,
  document.getElementById("root")
);
